import React from 'react';

const ListSearchIcon: React.FC = () => (
  <svg width="74" height="75" viewBox="0 0 74 75" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M64.7906 65.0162L58.141 58.3665L51.4913 51.7169M58.9435 57.564L65.5932 64.2137L63.9881 65.8188L57.3384 59.1691M58.676 34.443C58.676 47.9511 47.7255 58.9016 34.2174 58.9016C20.7093 58.9016 9.75879 47.9511 9.75879 34.443C9.75879 20.9349 20.7093 9.98438 34.2174 9.98438C47.7255 9.98438 58.676 20.9349 58.676 34.443Z"
      stroke="#475467"
      strokeWidth="4.58599"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M21.7188 29.9688L21.7188 27.8542C21.7187 25.018 24.018 22.7188 26.8542 22.7188L40.1458 22.7187C42.982 22.7187 45.2813 25.018 45.2813 27.8542L45.2813 29.9687L21.7188 29.9688Z"
      fill="#00A389"
    />
    <path d="M30.1771 46.2812L36.8229 46.2812L36.8229 31.7812L30.1771 31.7812L30.1771 46.2812Z" fill="#00A389" />
    <g opacity="0.4">
      <path
        d="M45.2812 31.7812L45.2813 41.1458C45.2813 43.982 42.982 46.2813 40.1458 46.2813L38.6354 46.2813L38.6354 31.7813L45.2812 31.7812Z"
        fill="#00A389"
      />
      <path
        d="M28.3646 46.2813L26.8542 46.2813C24.018 46.2813 21.7188 43.982 21.7188 41.1458L21.7188 31.7813L28.3646 31.7813L28.3646 46.2813Z"
        fill="#00A389"
      />
    </g>
  </svg>
);

export default ListSearchIcon;
